import { useEffect, useRef } from 'react';

import { CardModal, CustomScrollViewProps } from 'components/card-modal';

import { CartContent } from './components/cart-content';
import { CartContentDebug } from './components/cart-debug';
import { CartDebugFooter } from './components/cart-debug/cart-debug-footer';
import { CartFooter } from './components/cart-footer';
import { CartHeader } from './components/cart-header';
import { useCartContext } from './hooks/use-cart-context';
import { useCartIncentivesEvaluation } from './hooks/use-cart-incentives-evaluation';
import { useInitLoyaltyDependencies } from './hooks/use-init-loyalty';

export const CartScreen = () => {
  const { debug, cartEntries } = useCartContext();
  const cartScrollView = useRef<CustomScrollViewProps>(undefined);
  useInitLoyaltyDependencies();
  const { evaluateCartIncentives } = useCartIncentivesEvaluation({ cartEntries });

  useEffect(() => {
    evaluateCartIncentives();
  }, [evaluateCartIncentives]);

  return (
    <CardModal
      key="cart"
      _headerOverride={<CartHeader />}
      scrollViewRef={cartScrollView}
      scrollView
      webAnimate={false}
      standardPadding
      invertHeaderColor
      isFullScreen
      footer={debug ? <CartDebugFooter /> : <CartFooter />}
    >
      {debug ? <CartContentDebug /> : <CartContent />}
    </CardModal>
  );
};
